// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Oi4N","top":"styles_top__3WHxe"};